import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-clipart',
  templateUrl: './mobile-clipart.component.html',
  styleUrls: ['./mobile-clipart.component.scss']
})
export class MobileClipartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
